const CATEGORY_SPACES = 4;

const DESCRIPTION_SPACES = 3;

export const FORMAT_SPACES = {
  category: CATEGORY_SPACES,
  description: DESCRIPTION_SPACES,
};
